import { z } from 'zod';

export const AuditLogSchema = z.object({
  id: z.number(),
  userId: z.number().nullable(),
  action: z.string(),
  entityType: z.string(),
  entityId: z.number().nullable(),
  entityKey: z.string().nullable(),
  details: z.unknown().nullable(),
  ipAddress: z.string().nullable(),
  createdAt: z.coerce.date(),
});

export type AuditLog = z.infer<typeof AuditLogSchema>;

export const ListAuditLogsQuerySchema = z.object({
  userId: z.coerce.number().optional(),
  entityId: z.coerce.number().optional(),
  action: z.string().optional(),
  entityType: z.string().optional(),
  dateFrom: z.coerce.date().optional(),
  dateTo: z.coerce.date().optional(),
  page: z.coerce.number().min(1).default(1),
  pageSize: z.coerce.number().min(1).max(100).default(25),
});

export type ListAuditLogsQuery = z.infer<typeof ListAuditLogsQuerySchema>;

export const AuditLogListResponseSchema = z.object({
  items: z.array(AuditLogSchema),
  total: z.number(),
  page: z.number(),
  pageSize: z.number(),
});

export type AuditLogListResponse = z.infer<typeof AuditLogListResponseSchema>;
